import React from 'react';
import { Button, Card, Input, List, Modal, Select, Space, Tag, Typography } from 'antd';
import { formatDate } from 'utils/date';

const { Text } = Typography;

const Mobile = ({ viewModel }) => {
  const {
    filteredData,
    keyword,
    onKeywordChange,
    packageFilter,
    onPackageFilterChange,
    expiryFilter,
    onExpiryFilterChange,
    getPackageName,
    openRenewModal,
    renewTarget,
    packages,
    renewPackageKey,
    setRenewPackageKey,
    renewDuration,
    setRenewDuration,
    renewSubmitting,
    closeRenewModal,
    submitRenew,
    createDemoOpen,
    createDemoShopName,
    createDemoSubmitting,
    createDemoResult,
    openCreateDemoModal,
    closeCreateDemoModal,
    onCreateDemoShopNameChange,
    submitCreateDemo,
    closeCreateDemoResult,
    copyText,
    copyAllCredentials,
    goToDetail,
  } = viewModel;

  return (
    <div style={{ display: 'grid', gap: 10 }}>
      <Input
        size='middle'
        placeholder='Tìm shop / chủ shop / SĐT'
        allowClear
        value={keyword}
        onChange={onKeywordChange}
      />

      <Select value={expiryFilter} style={{ width: '100%' }} onChange={onExpiryFilterChange}>
        <Select.Option value='all'>Tất cả hạn dùng</Select.Option>
        <Select.Option value='expiring_7d'>Sắp hết hạn (7 ngày)</Select.Option>
      </Select>

      <Select value={packageFilter} style={{ width: '100%' }} onChange={onPackageFilterChange}>
        <Select.Option value='all'>Tất cả gói</Select.Option>
        {(packages || []).map((item) => (
          <Select.Option key={item.key} value={item.key}>{item.name}</Select.Option>
        ))}
      </Select>

      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button type='primary' onClick={openCreateDemoModal}>Tạo shop demo nhanh</Button>
      </div>

      <List
        dataSource={filteredData || []}
        locale={{ emptyText: 'Chưa có shop' }}
        renderItem={(record) => (
          <List.Item style={{ padding: 0, border: 'none' }}>
            <Card
              size='small'
              style={{ width: '100%', marginBottom: 12 }}
              bodyStyle={{ padding: 12 }}
            >
              <Space direction='vertical' size={6} style={{ width: '100%' }}>
                <Space style={{ justifyContent: 'space-between', width: '100%' }}>
                  <Space>
                    <Text strong>{record?.web_site?.title || '-'}</Text>
                    {record?.is_demo || record?.shop_type === 'demo' ? <Tag color='blue'>Demo</Tag> : null}
                  </Space>
                  <a href={`https://${record?.web_site?.url}.sipro.store`} target='_blank' rel='noreferrer'>Xem</a>
                </Space>

                <Text type='secondary'>Tạo lúc: {formatDate(record?.create_on)}</Text>
                <Space>
                  <Text>Gói cước: {getPackageName(record)}</Text>
                  {getPackageName(record) === 'invalidate' ? <Tag color='red'>Invalidate</Tag> : null}
                </Space>
                {record?.subscription?.tier && record?.subscription?.tier !== 'mien_phi' && (
                  <Text type='secondary'>Hết hạn: {formatDate(record?.subscription?.expiry_on) || '-'}</Text>
                )}

                <Space direction='vertical' size={0} style={{ width: '100%' }}>
                  <Text>{record?.owner?.full_name || '-'}</Text>
                  <Text type='secondary'>{record?.owner?.phone || '-'}</Text>
                </Space>

                <Space size={12} wrap>
                  <Text>Sản phẩm: {record?.product_count || 0}</Text>
                  <Text>Đơn tháng này: {record?.order_count_month || 0}</Text>
                </Space>

                <Space>
                  <Button size='small' onClick={() => goToDetail(record.id)}>Xem thông tin</Button>
                  <Button onClick={() => openRenewModal(record)}>Gia hạn</Button>
                </Space>
              </Space>
            </Card>
          </List.Item>
        )}
      />

      <Modal
        title='Gia hạn gói cước'
        open={!!renewTarget}
        onCancel={closeRenewModal}
        onOk={submitRenew}
        okText='Xác nhận gia hạn'
        cancelText='Đóng'
        confirmLoading={renewSubmitting}
      >
        <Space direction='vertical' style={{ width: '100%' }}>
          <div>Shop: {renewTarget?.web_site?.title || '-'}</div>
          <div>
            <label>Gói cước</label>
            <Select value={renewPackageKey} style={{ width: '100%' }} onChange={setRenewPackageKey}>
              {(packages || []).map((item) => (
                <Select.Option key={item.key} value={item.key}>{item.name}</Select.Option>
              ))}
            </Select>
          </div>
          <div>
            <label>Số tháng</label>
            <Select value={renewDuration} style={{ width: '100%' }} onChange={setRenewDuration}>
              <Select.Option value={1}>1 tháng</Select.Option>
              <Select.Option value={3}>3 tháng</Select.Option>
              <Select.Option value={6}>6 tháng</Select.Option>
            </Select>
          </div>
        </Space>
      </Modal>

      <Modal
        title='Tạo shop demo nhanh'
        open={createDemoOpen}
        onCancel={closeCreateDemoModal}
        onOk={submitCreateDemo}
        okText='Tạo shop'
        cancelText='Đóng'
        confirmLoading={createDemoSubmitting}
      >
        <Input
          placeholder='Nhập tên shop'
          value={createDemoShopName}
          onChange={onCreateDemoShopNameChange}
          maxLength={120}
        />
      </Modal>

      <Modal
        title='Thông tin đăng nhập shop demo'
        open={!!createDemoResult}
        onCancel={closeCreateDemoResult}
        footer={[
          <Button key='copy' onClick={copyAllCredentials}>Copy tất cả</Button>,
          <Button key='close' type='primary' onClick={closeCreateDemoResult}>Đóng</Button>,
        ]}
      >
        <Space direction='vertical' style={{ width: '100%' }}>
          <div>
            Shop URL: <a href={`https://${createDemoResult?.shop_url}.sipro.store`} target='_blank' rel='noreferrer'>{`https://${createDemoResult?.shop_url}.sipro.store`}</a>
          </div>
          <Space>
            Username: {createDemoResult?.username || '-'}
            <Button size='small' onClick={() => copyText(createDemoResult?.username, 'username')}>Copy</Button>
          </Space>
          <Space>
            Login ID: {createDemoResult?.login_id || '-'}
            <Button size='small' onClick={() => copyText(createDemoResult?.login_id, 'login id')}>Copy</Button>
          </Space>
          <Space>
            Password: {createDemoResult?.password || '-'}
            <Button size='small' onClick={() => copyText(createDemoResult?.password, 'mật khẩu')}>Copy</Button>
          </Space>
          <div>Workspace ID: {createDemoResult?.w_id || '-'}</div>
        </Space>
      </Modal>
    </div>
  );
};

export default Mobile;